import bigInt from 'big-integer';
import React, { useState } from 'react';
import { Modal, Button, Icon, CalendarDatePicker } from '../_components';
import { useModal } from '../_contexts';
//-----------------------
import { ChronosDate } from '../_helpers';
import { gregorianCalendar } from '../_helpers/_calendars';
import { testCalendar } from '../_helpers/_calendars';

export function ChronosTester() {
  const [testDate, setTestDate] = useState('-94608000');
  const { closeModal } = useModal();
  // console.clear();
  const runTests = () => {
    console.clear();
    // To Relative Testing
    gregorianZeroToRelative();
    gregorianM500DToRelative();
    gregorianM5000DToRelative();
    gregorianP500DToRelative();
    gregorianP5000DToRelative();
    gregorianM1DToRelative();

    testZeroToRelative();
    testM500DToRelative();
    testM5000DToRelative();
    testP500DToRelative();
    testP5000DToRelative();
    // To elapsed Seconds testing
    gregorianM500DToSeconds();
    gregorianM5000DToSeconds();
    gregorianP5000DToSeconds();
    testM5000DToSeconds();
    testP500DToSeconds();
  };

  const gregorianZeroToRelative = () => {
    let date = new ChronosDate('0');
    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === 0 &&
      relativeDate.month === 0 &&
      relativeDate.day === 1
    ) {
      console.log('Success gregorianZeroToRelative');
    } else {
      console.error('gregorianZeroToRelative Error', { ...relativeDate });
    }
  };

  const gregorianM500DToRelative = () => {
    // console.clear();
    let date = new ChronosDate('-43200000'); // - 500 days, 230th day of -2 => august 18th
    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === -2 &&
      relativeDate.month === 7 &&
      relativeDate.day === 19
    ) {
      console.log('Success gregorianM500DToRelative');
    } else {
      console.error('gregorianM500DToRelative Error', { ...relativeDate });
    }
  };
  const gregorianM5000DToRelative = () => {
    // console.clear();
    let date = new ChronosDate('-432000000');
    /**
     *  - 5000 days in the past,
     * (365+365+365+366) => 1461 full day cycle
     * 3 cycles => 4383
     *  -365
     *  252 off set so  113th day of - (3*4+1+1) => 24 april of -14 */
    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === -14 &&
      relativeDate.month === 3 &&
      relativeDate.day === 24
    ) {
      console.log('Success gregorianM5000DToRelative');
    } else {
      console.error('gregorianM5000DToRelative Error', { ...relativeDate });
    }
  };
  const gregorianM1DToRelative = () => {
    // console.clear();
    let date = new ChronosDate('-86400');
    /**
     *  - 1 days in the past,
     */
    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === -1 &&
      relativeDate.month === 11 &&
      relativeDate.day === 31
    ) {
      console.log('Success gregorianM1DToRelative');
    } else {
      console.error('gregorianM1DToRelative Error', { ...relativeDate });
    }
  };
  const gregorianP500DToRelative = () => {
    // console.clear();
    let date = new ChronosDate('43200000'); // + 500 days, 135th day of +2 => MAy 15+2
    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === 1 &&
      relativeDate.month === 4 &&
      relativeDate.day === 15
    ) {
      console.log('Success gregorianP500DToRelative');
    } else {
      console.error('gregorianP500DToRelative Error', { ...relativeDate });
    }
  };
  const gregorianP5000DToRelative = () => {
    // console.clear();
    let date = new ChronosDate('432000000');
    /**
     *  - 5000 days in the past,
     * (365+365+365+366) => 1461 full day cycle
     * 3 cycles => 4383
     *  -365
     *  252th day of + (3*4+1) => september 9th of +13 */
    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === 13 &&
      relativeDate.month === 8 &&
      relativeDate.day === 9
    ) {
      console.log('Success gregorianP5000DToRelative');
    } else {
      console.error('gregorianP5000DToRelative Error', { ...relativeDate });
    }
  };

  /**
   * ======================================================================
   * Test Calendar
   * ======================================================================
   */

  const testZeroToRelative = () => {
    let date = new ChronosDate('0', { calendar: testCalendar });

    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === 0 &&
      relativeDate.month === 0 &&
      relativeDate.day === 1
    ) {
      console.log('Success testZeroToRelative');
    } else {
      console.error('testZeroToRelative Error', { ...relativeDate });
    }
  };
  const testM500DToRelative = () => {
    let date = new ChronosDate('-43200000', { calendar: testCalendar });

    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === -5 &&
      relativeDate.month === 5 &&
      relativeDate.day === 1
    ) {
      console.log('Success testM500DToRelative');
    } else {
      console.error('Error testM500DToRelative', { ...relativeDate });
    }
  };

  const testM5000DToRelative = () => {
    let date = new ChronosDate('-432000000', { calendar: testCalendar });

    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === -42 &&
      relativeDate.month === 0 &&
      relativeDate.day === 1
    ) {
      console.log('Success testM5000DToRelative');
    } else {
      console.error('testM5000DToRelative Error', { ...relativeDate });
    }
  };

  const testP500DToRelative = () => {
    let date = new ChronosDate('43200000', { calendar: testCalendar });

    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === 3 &&
      relativeDate.month === 5 &&
      relativeDate.day === 1
    ) {
      console.log('Success testP500DToRelative');
    } else {
      console.error('testP500DToRelative Error', { ...relativeDate });
    }
  };
  const testP5000DToRelative = () => {
    let date = new ChronosDate('432000000', { calendar: testCalendar });

    let relativeDate = date.toRelativeDate();
    if (
      relativeDate.year === 40 &&
      relativeDate.month === 9 &&
      relativeDate.day === 61
    ) {
      console.log('Success testP5000DToRelative');
    } else {
      console.error('testP5000DToRelative Error', { ...relativeDate });
    }
  };
  /**
   * =======================================================================================
   * To Seconds testing
   * =======================================================================================
   *      Gregorian Calendar
   * =======================================================================================
   */
  const gregorianM500DToSeconds = () => {
    const obj = {
      year: -1,
      day: -135,
      hour: 0,
      minute: 0,
      second: 0,
    };
    console.log('Date Object: ', { ...obj });
    const newDate = new ChronosDate('0').setDateFromObject(obj);
    if ('-43200000' === newDate) {
      console.log('success');
    } else {
      console.log('ERROR', newDate, 'Expected ', '-43200000');
    }
  };

  const gregorianM5000DToSeconds = () => {
    const obj = {
      year: -13,
      day: -252,
      hour: 0,
      minute: 0,
      second: 0,
    };
    console.log('Date Object: ', { ...obj });
    const newDate = new ChronosDate('0').setDateFromObject(obj);
    if ('-432000000' === newDate) {
      console.log('success');
    } else {
      console.log('ERROR', newDate, 'Expected ', '-432000000');
    }
  };

  const gregorianP5000DToSeconds = () => {
    const obj = {
      year: 13,
      day: 251,
      hour: 0,
      minute: 0,
      second: 0,
    };
    console.log('Date Object: ', { ...obj });
    const newDate = new ChronosDate('0').setDateFromObject(obj);
    if ('432000000' === newDate) {
      console.log('success');
    } else {
      console.log('ERROR', newDate, 'Expected ', '432000000');
    }
  };

  const testM5000DToSeconds = () => {
    const obj = {
      year: -42,
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
    };
    console.log('Date Object: ', { ...obj });
    const newDate = new ChronosDate('0', {
      calendar: testCalendar,
    }).setDateFromObject(obj);
    if ('-432000000' === newDate) {
      console.log('success');
    } else {
      console.log('ERROR', newDate, 'Expected ', '-432000000');
    }
  };

  const testP500DToSeconds = () => {
    const obj = {
      year: 3,
      day: 50,
      hour: 0,
      minute: 0,
      second: 0,
    };
    console.log('Date Object: ', { ...obj });
    const newDate = new ChronosDate('0', {
      calendar: testCalendar,
    }).setDateFromObject(obj);
    if ('43200000' === newDate) {
      console.log('success');
    } else {
      console.log('ERROR', newDate, 'Expected ', '43200000');
    }
  };
  // ===================================================================================

  const runEventTests = () => {
    console.clear();
    dateToAbsolute();
  };

  const dateToAbsolute = () => {
    let dateString = '-94608000';
    let dateObj = new ChronosDate(dateString).toFullObject();
    console.log('Date Object', dateObj);
  };

  const handleDateChange = (data) => {
    setTestDate(data);
  };

  // ==========================================================================
  const runConversionTests = () => {
    console.clear();
    conversionTestOne('2348803802');
    conversionTestOne('5904043');
    conversionTestOne('-87903458097453');
    conversionTestOne('-342232');
  };

  const conversionTestOne = (dateString) => {
    console.group(`Conversion Test: ${dateString}`);
    const date = new ChronosDate(dateString, { calendar: gregorianCalendar });
    const absolute = date.toFullObject();
    const relative = date.toRelativeDate();
    const convertedAbsolute = date.setDateFromObject(absolute);
    console.log('-------------------------');
    const convertedRelative = date.setDateFromObject(
      date.convertRelativeToAbsolute(relative)
    );
    console.log('-------------------------');
    console.log('DateString: ', dateString.slice());
    console.log('Absolute (Object): ', { ...absolute });
    console.log('Relative (Object): ', { ...relative });
    console.log('Absolute (Converted): ', convertedAbsolute.slice());
    console.log('Relative (Converted): ', convertedRelative.slice());
    if (convertedAbsolute === convertedRelative) {
      console.log('Test Passed!');
    } else {
      const diff = bigInt(convertedAbsolute)
        .minus(convertedRelative)
        .toString();
      console.error(
        `Test Failed! String: "${dateString}" Difference is ${diff} seconds.`
      );
    }
    console.groupEnd();
  };

  return (
    <Modal
      id="CHRONOTESTER"
      backdrop
      title="Chronos Tester"
      icon=""
      size="md"
      open
      onClose={() => closeModal()}
    >
      <div className="chronos-tester-component">
        <Button onClick={runTests}>'0' date Tests</Button>
        <Button onClick={runEventTests}>Event Tests</Button>
        <Button onClick={runConversionTests}>Conversion Tests</Button>
        <p>DATESTRING: {testDate}</p>
        <CalendarDatePicker
          value={testDate}
          onChange={handleDateChange}
          calendar={gregorianCalendar}
        />
      </div>
    </Modal>
  );
}
